"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragablePaper = void 0;
const react_1 = __importStar(require("react"));
const react_draggable_1 = __importDefault(require("react-draggable"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const dialog_context_1 = require("../dialog/dialog-context");
function DragablePaper(props) {
    const { handleId } = (0, react_1.useContext)(dialog_context_1.DialogContext);
    return (react_1.default.createElement(react_draggable_1.default, { handle: `#${handleId}`, cancel: '[class*="MuiDialogContent-root"], [class*="MuiDialogActions-root"]' },
        react_1.default.createElement(Paper_1.default, { ...props })));
}
exports.DragablePaper = DragablePaper;
//# sourceMappingURL=draggable-paper.js.map